<template>
    <div class="form-group">
      <label class="control-label">Approval Information</label>
      <div class="table-responsive">
        <table class="table table-hover table-striped" aria-label="List Supervisor">
          <thead>
          <tr>
            <th style="min-width:10px" id="level"> Level </th>
            <th id="name"> Name </th>
            <th id="email"> Email </th>
            <th id="status"> Status </th>
            <th id="date"> Date </th>
          </tr>
          </thead>
          <tbody >
          <tr v-for="(data, i) in list_supervisor">
            <td>{{data.level}}</td>
            <td>{{data.name}}</td>
            <td>{{data.email}}</td>
            <td>{{data.status_name}}</td>
            <td>{{data.status_date}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
export default {
  name: "ListSupervisorFinish",
  props:{
    list_supervisor:{
      type:Array
    }
  }
}
</script>